export default "__VITE_ASSET__CVnywUrY__"